import { LocalStorageService } from '@/domains/local-storage/types/local-storage-service.interface';
import { useUserInfo } from '@/presentation/composables/user/use-user-info';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { createEventHook, createSharedComposable } from '@vueuse/core';
import _ from 'lodash';
import { ref } from 'vue';
const FILTER_ASIDE_PANEL_VISIBLE_KEY = 'FILTER_ASIDE_PANEL_VISIBLE_KEY';
export const useFilterAside = createSharedComposable(() => {
    const localStorageService = injectService(LocalStorageService);
    const { isFree } = useUserInfo();
    const isFilterAsideVisible = ref(false);
    const visibleToggledHook = createEventHook();
    const toggleFilterAside = () => {
        isFilterAsideVisible.value = !isFilterAsideVisible.value;
        visibleToggledHook.trigger(isFilterAsideVisible.value);
        localStorageService.setItem(FILTER_ASIDE_PANEL_VISIBLE_KEY, isFilterAsideVisible.value);
    };
    const init = () => {
        const visible = isFree.value ? false : localStorageService.getItem(FILTER_ASIDE_PANEL_VISIBLE_KEY);
        if (_.isBoolean(visible)) {
            isFilterAsideVisible.value = visible;
        }
    };
    init();
    return {
        isFilterAsideVisible,
        toggleFilterAside,
        onVisibleToggled: visibleToggledHook.on,
    };
});
